/**
 * @generated SignedSource<<d31fb71b6f85636fd5a884f47bac8ce5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchivedCalendarsQuery$variables = Record<PropertyKey, never>;
export type ArchivedCalendarsQuery$data = {
  readonly store: {
    readonly archivedCalendars: ReadonlyArray<{
      readonly color: string;
      readonly id: string;
      readonly title: string;
    }>;
  };
};
export type ArchivedCalendarsQuery = {
  response: ArchivedCalendarsQuery$data;
  variables: ArchivedCalendarsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreCalendar",
  "kind": "LinkedField",
  "name": "archivedCalendars",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchivedCalendarsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ArchivedCalendarsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a9f4bfcf6119964608d99afacc2d3e26",
    "id": null,
    "metadata": {},
    "name": "ArchivedCalendarsQuery",
    "operationKind": "query",
    "text": "query ArchivedCalendarsQuery {\n  store {\n    archivedCalendars {\n      id\n      title\n      color\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "25fd81178c943b7ed2844a000832f52b";

export default node;
